import { UStack } from '@src/components'

import { PageFlexHeaderProps } from './type'
import { PageHeader } from '../page-header'

/**
 * Use PageContainer to ensure margin-bottom.
 */
export const PageFlexHeader = ({
  title,
  description,
  children,
}: PageFlexHeaderProps) => {
  return (
    <UStack direction="row" justifyContent="space-between">
      <PageHeader title={title} description={description} />
      <div>{children}</div>
    </UStack>
  )
}
